import { useState, useEffect } from "react";
import { browserLanguage } from "../../helper";

const useI18n = (data, options = {}) => {
  const [state, setState] = useState({
    lang: options.lang || browserLanguage,
    fallback: options.fallback || "en",
    i18n: {},
    translate: lang =>
      setState({
        lang,
        i18n:
          data[state.lang] ||
          data[state.lang.split("-")[0]] ||
          data[state.fallback] ||
          data[state.fallback.split("-")[0]],
      }),
  });

  useEffect(() => {
    state.translate(state.lang);
  }, [state]);
};

export default useI18n;
